import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import { showSuccessMsg } from '../../util/messagesUtil';
import buscarTomadores from '../../actions/cteos/tomador/buscarTomadores'
import Tomador from './Tomador';
import ModalCadastrarTomador from './ModalCadastrarTomador';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import excluirTomador from '../../actions/cteos/tomador/excluirTomador';
import PaginacaoTomador from './PaginacaoTomador';
import BotoesPaginacaoTomador from './BotoesPaginacaoTomador';
import determinarPaginaAtualTomadores from '../../actions/cteos/tomador/determinarPaginaAtualTomador';
import alterarRegistrosPorPaginaTomadores from '../../actions/cteos/tomador/alterarRegistrosPorPaginaTomadores';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import PainelFiltrosTomador from './PainelFiltrosTomador';

const ModalConfirmacaoExclusaoTomador = ({ tomador, excluir }) => {
    const nome = tomador ? (tomador.tipoTomador === 'PF' ? tomador.nomePessoa : tomador.nomeFantasia) : '';
    return (
        <div className="modal fade" id="modalConfirmacaoExclusaoTomador" tabIndex="-1" role="dialog"
            aria-labelledby="modalConfirmacaoExclusaoTomador" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content vx-modal-content">
                    <div className="vx-modal-header">
                        <div className="vx-modal-header-left">
                            <i className="material-icons">delete</i>
                            <span className="vx-modal-title">Excluir Tomador</span>
                        </div>
                        <button type="button" className="vx-modal-close" data-dismiss="modal">
                            <i className="material-icons">close</i>
                        </button>
                    </div>
                    <div className="vx-modal-body">
                        <p style={{margin: 0}}>Deseja excluir o tomador: <strong>{nome}</strong>?</p>
                    </div>
                    <div className="vx-modal-footer">
                        <button type="button" className="vx-btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" className="vx-btn-primary" data-dismiss="modal"
                            onClick={() => excluir()}>
                            <i className="material-icons">delete</i>
                            Excluir
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const CabecalhoTabela = () => (
    <div className="vx-gp-table-header vx-gp-table-header--tomador d-none d-lg-grid">
        <div>Nome</div>
        <div>CNPJ/CPF</div>
        <div>Ações</div>
    </div>
);


export class PainelGerenciarTomador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tomadorSelecionado: null
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualTomadores(1)
    }

    componentDidMount() {
        this.buscarTomadores();
    }

    buscarTomadores() {
        this.props.buscarTomadores(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtualTomadores(1);
                this.props.alterarRegistrosPorPaginaTomadores(10);
            }
            this.buscarTomadores();
        }
    }

    selecionarTomador(tomador) {
        this.setState({ tomadorSelecionado: tomador });
    }

    excluirTomador() {
        this.props.excluirTomador(this.state.tomadorSelecionado.id).then(() => {
            showSuccessMsg('Tomador removido com sucesso!');
            this.buscarTomadores();
        });
    }

    exibirBotaoNovoTomador() {
        return (
            <div className="vx-gp-toolbar">
                <button data-toggle="modal" data-target="#modalCadastrarTomador" className="vx-btn-primary">
                    <span className="material-icons">add</span>
                    Novo Tomador
                </button>
            </div>
        );
    }

    exibirTabelaTomadores() {
        const { tomadores } = this.props;
        if (tomadores && tomadores.length) {
            return (
                <div className="col-12 conteudo-internas">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoTomador}
                        BotoesPaginacao={BotoesPaginacaoTomador}
                        cupom={tomadores}>
                        <CabecalhoTabela />
                        <div>
                            {this.exibirTomadores()}
                        </div>
                    </CabecalhoRodapeTabela>
                </div>
            );
        }
        return (
            <div className="vx-gp-empty">
                <span className="material-icons vx-gp-empty-icon">people_alt</span>
                <p className="vx-gp-empty-text">Nenhum tomador cadastrado.</p>
            </div>
        );
    }

    exibirTomadores() {
        const { tomadores } = this.props;
        if (tomadores) {
            return tomadores.map((tomador, index) => (
                <Tomador key={index} tomador={tomador}
                    selecionarTomador={this.selecionarTomador.bind(this)}
                />
            ));
        }
    }

    render() {
        return (
            <div>
                <div className="row internas">
                    <Titulo texto="Gerenciar Tomadores" urlRetorno="/menu-cteos" />
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                        <div className="col-12 conteudo-internas conteudo-painel area-btn-filtro-painel">
                            <div className="col-12 filtro-busca">
                                <PainelFiltrosTomador />
                            </div>
                            {this.exibirBotaoNovoTomador()}
                            {this.exibirTabelaTomadores()}
                            <ModalCadastrarTomador buscarTomadores={this.buscarTomadores.bind(this)} />
                            <ModalConfirmacaoExclusaoTomador tomador={this.state.tomadorSelecionado} excluir={this.excluirTomador.bind(this)} />
                        </div>
                    </Autorizacao>
                </div>
            </div>
        );
    }
}


export const mapStateToProps = state => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        tomadores: state.tomador.tomadores,
        changeFieldValue,
        paginaAtual: state.tomador.paginaAtualTomadores,
        registrosPorPagina: state.tomador.registrosPorPaginaTomadores,
        filtrosAdicionados: state.filtrosAdicionadosTomador
    }
};


export default connect(mapStateToProps, {
    buscarTomadores,
    excluirTomador,
    determinarPaginaAtualTomadores,
    alterarRegistrosPorPaginaTomadores
})(reduxForm({
    form: 'formularioCadastroCupom'
})(PainelGerenciarTomador))
